import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface ViewMoreIconProps extends SvgIconProps {}

export const ViewMoreIcon = ({
  style,
  ...iconProps
}: ViewMoreIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon
      style={style}
      {...iconProps}
      width="4"
      height="22"
      viewBox="0 0 4 22"
      fill="none"
    >
      <path
        d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z"
        fill="#A7A7A7"
      />
      <path
        d="M2 13C3.10457 13 4 12.1046 4 11C4 9.89543 3.10457 9 2 9C0.89543 9 0 9.89543 0 11C0 12.1046 0.89543 13 2 13Z"
        fill="#A7A7A7"
      />
      <path
        d="M2 22C3.10457 22 4 21.1046 4 20C4 18.8954 3.10457 18 2 18C0.89543 18 0 18.8954 0 20C0 21.1046 0.89543 22 2 22Z"
        fill="#A7A7A7"
      />
    </SvgIcon>
  );
};
